var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIceh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_472_6809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.44406 1.11656C4.33067 0.863153 4.07867 0.700216 3.80113 0.700685L0.701986 0.7057C0.467892 0.706075 0.249361 0.822935 0.119002 1.01742C-0.0113109 1.21186 -0.0362484 1.45842 0.0523453 1.67508L0.806564 3.51815H5.51891L4.44406 1.11656Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14809 4.92432H1.38184L1.89976 6.18999H6.71452L6.14809 4.92432Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1164 16.5493L17.8429 15.3186C17.7714 14.9969 17.4861 14.768 17.1565 14.768H11.5553C10.919 14.768 10.3942 14.411 10.1156 13.7884L7.34426 7.59619H2.47559L6.33171 17.0194C7.1832 19.1003 9.06195 20.393 11.2348 20.393H12.9376V19.4555C12.9376 17.853 14.2414 16.5493 15.8439 16.5493H18.1164Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 17.9556H15.8438C15.0166 17.9556 14.3438 18.6285 14.3438 19.4556V21.7993C14.3438 22.6264 15.0166 23.2993 15.8438 23.2993H22.5C23.3271 23.2993 24 22.6264 24 21.7993V19.4556C24 18.6285 23.3271 17.9556 22.5 17.9556Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_6809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceh);
export default __webpack_public_path__ + "static/media/ICEH.6a521d7fcb929ef5eb25b78faddaf812.svg";
export { ForwardRef as ReactComponent };